import { type DealDetailsTabs, dealDetailsTabs } from '@openx/types/deal.ts';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import type { DealRouteParams } from '../../types.ts';

export function useCurrentTab() {
  const { dealUid } = useParams<DealRouteParams>();
  const location = useLocation();
  const navigate = useNavigate();

  const pathPart = location.pathname.split('/').pop() as string;
  const currentTab = pathPart === dealUid ? dealDetailsTabs.DETAILS : (pathPart as DealDetailsTabs);
  const [activeTab, setActiveTab] = useState<DealDetailsTabs>(currentTab);

  useEffect(() => {
    const pathPart = location.pathname.split('/').pop() as string;
    const currentTab = pathPart === dealUid ? dealDetailsTabs.DETAILS : pathPart;
    if (currentTab !== activeTab && Object.values(dealDetailsTabs).includes(currentTab as DealDetailsTabs)) {
      setActiveTab(currentTab as DealDetailsTabs);
    }
  }, [dealUid, activeTab, location.pathname]);

  const changeTab = useCallback(
    (_, tab) => {
      setActiveTab(tab);
      navigate(`/deals/${dealUid}/${tab}`);
    },
    [dealUid, navigate]
  );

  return { activeTab, changeTab };
}
